// extracted by mini-css-extract-plugin
export var avatarContainer = "_a1-0";
export var avatarTypingWave = "_a1-i";
export var gray = "_a1-f";
export var green = "_a1-c";
export var icon = "_a1-9";
export var image = "_a1-1";
export var lg = "_a1-6";
export var md = "_a1-5";
export var presenceDot = "_a1-b";
export var red = "_a1-d";
export var sm = "_a1-4";
export var status = "_a1-a";
export var typingDot = "_a1-h";
export var typingPill = "_a1-g";
export var xl = "_a1-7";
export var xs = "_a1-3";
export var xxl = "_a1-8";
export var xxs = "_a1-2";
export var yellow = "_a1-e";